import z from "zod";
import { authedEndpoint } from "../../builder";

export const get = authedEndpoint.query(
    ({ id, search_params }) => ({
        method: "get",
        searchParams: search_params,
        url: `remote-storages/${id}`,
    }),
    {
        input: z.object({
            id: z.string(),
            search_params: z
                .object({
                    cursor: z.string(),
                    filter: z
                        .object({
                            name: z.string(),
                        })
                        .partial(),
                    per_page: z.number(),
                })
                .partial()
                .optional(),
        }),
        output: z.object({
            id: z.number(),
            name: z.string(),
            config: z.object({
                host: z.string(),
                password: z.string(),
                root: z.string().optional().nullable(),
                username: z.string(),
            }),
        }),
    },
);
